export default __webpack_public_path__ + "static/feature-banner-travel-accessories-d5afd48af49cd9a63992c35237f49ee8.jpg";